import isString from 'lodash/isString';

import { SEARCH_BASE_PATH } from './shared';

/**
 * Returns the search path for the given term and filter
 *
 * @param {string} [searchTerm] - searched term
 * @param {string} [filterType] - search filter
 * @returns path to search
 */
export function getSearchPathForTermAndType(searchTerm?: string, filterType?: string) {
  const paths = ['/search'];

  if (isString(searchTerm) && searchTerm.length > 0) {
    paths.push(`/${searchTerm}`);
  }

  if (isString(filterType) && filterType.length > 0) {
    paths.push(`/${filterType}`);
  } else {
    paths.push('/all');
  }

  return paths.join('');
}

export function getSearchT3Path() {
  return '/search/' as const;
}

export function isInSearchPath(path?: string): boolean {
  return path?.startsWith(SEARCH_BASE_PATH) ?? false;
}

export function isFilteredSearch(path: string): boolean {
  return /^\/search\/.*\/[a-zA-Z0-9_]*$/.test(path);
}

export function isInPodcastSearchPath(path: string): boolean {
  return /^\/search\/.*\/podcasts$/.test(path);
}
